import { createContext, useContext } from 'react';
import type { DrawerAnchor } from './types';
interface BodyDrawerContextValue {
  anchor: DrawerAnchor;
  onAnchorChange: (anchor: DrawerAnchor) => void;
}
export const BodyDrawerContext = createContext<BodyDrawerContextValue | null>(null);
export const useBodyDrawerContext = () => {
  const context = useContext(BodyDrawerContext);
  if (context == null) {
    throw new Error("BodyDrawer must be used within a Frame component");
  }
  return context;
};